// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.numerados-tabela {
    width: 100%;
    border-collapse: collapse;
  }
  
  .numerados-cabecalho {
    border-bottom: 1px solid var(--grey-shadow);
    border-top: 1px solid var(--grey-shadow);
    padding: 15px;
    text-align: center;
  }

  .numerados-rodape {
    border-bottom: 1px solid var(--grey-shadow);
    border-top: 1px solid var(--grey-shadow);
    padding: 15px;
    text-align: center;
    font-weight: bold;
  }
  
  .numerados-celula {
    border-bottom: 1px solid var(--grey-shadow);
    text-align: center;
  }

  .numerados-celula-left {
    border-bottom: 1px solid var(--grey-shadow);
    text-align: left;
    padding-left: 15px;
  }
  
  .numerados-botao-expandir {
    width: 30px;
    height: 30px;
    background-color: var(--blue);
    color: white;
    font-size: 18px;
    margin-right: 20px;
    margin-left: 10px;
    border: none
  }
  
  
  .numerados-conteudo-expandido {
    border-bottom: 1px solid var(--grey-shadow);
    text-align: center;
  }

  .numerados-conteudo-expandido-left {
    border-bottom: 1px solid var(--grey-shadow);
    text-align: left;
    padding-left: 15px;
  }

  .numerados-botao-expandir2 {
    width: 30px;
    height: 30px;
    background-color: lightblue;
    color: rgb(0, 0, 0);
    font-size: 18px;
    margin-right: 20px;
    margin-left: 10px;
    border: none
  }
  
  .numerados-conteudo-expandido2 {
    border-bottom: 1px solid var(--blue-shadow);
    text-align: center;
  }
  
  .numerados-linha-branca {
    background-color: #ffffff;
  }
  
  .numerados-linha-cinza {
    background-color: #f2f2f2;
  }

  .numerados-linha-azul {
    background-color: lightblue;
    font-weight: bold;
    border-bottom: 1px solid var(--grey-shadow);
    text-align: center;
  }

  .numerados-linha-azul-left {
    background-color: lightblue;
    font-weight: bold;
    border-bottom: 1px solid var(--grey-shadow);
    text-align: left;
    padding-left: 15px;
  }
  

.disponivel-cell {
  background-color: rgb(71, 175, 71);
  color: white;
}

.parcial-cell {
  background-color: rgb(231, 231, 158);
}

.vendido-cell {
  background-color: rgb(215, 70, 70);
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/components/Tables/Numerados/tableNumerados.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,2CAA2C;IAC3C,wCAAwC;IACxC,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,2CAA2C;IAC3C,wCAAwC;IACxC,aAAa;IACb,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,2CAA2C;IAC3C,kBAAkB;EACpB;;EAEA;IACE,2CAA2C;IAC3C,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB;EACF;;;EAGA;IACE,2CAA2C;IAC3C,kBAAkB;EACpB;;EAEA;IACE,2CAA2C;IAC3C,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB;EACF;;EAEA;IACE,2CAA2C;IAC3C,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,2CAA2C;IAC3C,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,2CAA2C;IAC3C,gBAAgB;IAChB,kBAAkB;EACpB;;;AAGF;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd","sourcesContent":[".numerados-tabela {\n    width: 100%;\n    border-collapse: collapse;\n  }\n  \n  .numerados-cabecalho {\n    border-bottom: 1px solid var(--grey-shadow);\n    border-top: 1px solid var(--grey-shadow);\n    padding: 15px;\n    text-align: center;\n  }\n\n  .numerados-rodape {\n    border-bottom: 1px solid var(--grey-shadow);\n    border-top: 1px solid var(--grey-shadow);\n    padding: 15px;\n    text-align: center;\n    font-weight: bold;\n  }\n  \n  .numerados-celula {\n    border-bottom: 1px solid var(--grey-shadow);\n    text-align: center;\n  }\n\n  .numerados-celula-left {\n    border-bottom: 1px solid var(--grey-shadow);\n    text-align: left;\n    padding-left: 15px;\n  }\n  \n  .numerados-botao-expandir {\n    width: 30px;\n    height: 30px;\n    background-color: var(--blue);\n    color: white;\n    font-size: 18px;\n    margin-right: 20px;\n    margin-left: 10px;\n    border: none\n  }\n  \n  \n  .numerados-conteudo-expandido {\n    border-bottom: 1px solid var(--grey-shadow);\n    text-align: center;\n  }\n\n  .numerados-conteudo-expandido-left {\n    border-bottom: 1px solid var(--grey-shadow);\n    text-align: left;\n    padding-left: 15px;\n  }\n\n  .numerados-botao-expandir2 {\n    width: 30px;\n    height: 30px;\n    background-color: lightblue;\n    color: rgb(0, 0, 0);\n    font-size: 18px;\n    margin-right: 20px;\n    margin-left: 10px;\n    border: none\n  }\n  \n  .numerados-conteudo-expandido2 {\n    border-bottom: 1px solid var(--blue-shadow);\n    text-align: center;\n  }\n  \n  .numerados-linha-branca {\n    background-color: #ffffff;\n  }\n  \n  .numerados-linha-cinza {\n    background-color: #f2f2f2;\n  }\n\n  .numerados-linha-azul {\n    background-color: lightblue;\n    font-weight: bold;\n    border-bottom: 1px solid var(--grey-shadow);\n    text-align: center;\n  }\n\n  .numerados-linha-azul-left {\n    background-color: lightblue;\n    font-weight: bold;\n    border-bottom: 1px solid var(--grey-shadow);\n    text-align: left;\n    padding-left: 15px;\n  }\n  \n\n.disponivel-cell {\n  background-color: rgb(71, 175, 71);\n  color: white;\n}\n\n.parcial-cell {\n  background-color: rgb(231, 231, 158);\n}\n\n.vendido-cell {\n  background-color: rgb(215, 70, 70);\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
